module.exports = __webpack_public_path__ + "static/light-reading-2825284b2b8a3dd227f3627a0111410e.gif";